import React from 'react';
import Uganda_p6math from './uganda_p6math';
import Uganda_p6_subjects from './uganda_p6_subjects';
import Speech from "react-text-to-speech";


const Uganda_p6math_form_complement_of_sets = () => {
  return (
    < >  
    
    <Uganda_p6_subjects /> 
    <Uganda_p6math />
   
<div class=" right-0 left-0 bottom-0 top-38 min-h-screen scrollbar-hide relative inset-0 items-center justify-center bg-cyan-50 bg-opacity-30">
  <section className='flex'>
     <Speech text="Form complement of a set!" stableText={true} /> 
     <p>Form complement of a set</p>  
     </section>
     
     <p>In this section we are going to look at how complements of sets are formed from sets. </p> 
     <p>We shall also look at thes in conjunction with the following:</p>
     <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>
      <p>In this section we are going to look at how complements of sets are formed from sets. </p> 
     
     <p>We shall also look at thes in conjunction with the following:</p>
     <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>
      <p>In this section we are going to look at how complements of sets are formed from sets. </p> 
     <p>We shall also look at thes in conjunction with the following:</p>
     <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>
      <p>In this section we are going to look at how complements of sets are formed from sets. </p> 
     
     <p>We shall also look at thes in conjunction with the following:</p>
     <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>
      <p>In this section we are going to look at how complements of sets are formed from sets. </p> 
     <p>We shall also look at thes in conjunction with the following:</p>
     <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>
      <p>In this section we are going to look at how complements of sets are formed from sets. </p> 
     <p>We shall also look at thes in conjunction with the following:</p>
     <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>

      <p>We shall also look at thes in conjunction with the following:</p>
     <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>
      <p>In this section we are going to look at how complements of sets are formed from sets. </p> 
     <p>We shall also look at thes in conjunction with the following:</p>
     <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>
      <p>In this section we are going to look at how complements of sets are formed from sets. </p> 
     <p>We shall also look at thes in conjunction with the following:</p>
     <li>Generic skills or Soft skills or 21st century skills integrated in Math learning and assessment </li>
      <li>Cross-cutting isues integrated in Math learning and assessment </li>
      <li>Values integrated in Math learning and assessment </li>
      </div>
    </>
  );
}

export default Uganda_p6math_form_complement_of_sets;
